<div>
  <img class="inline-block" [style.height]="height" [style.width]="width" [class.light]="color === 'light'" src="/assets/images/logo.svg" loading="lazy">

  <span class="ms-2">Prototype</span>
</div>
